var map = {
	"./amico-logo.svg": "ac67",
	"./bubble-logo.svg": "1b81",
	"./cbat.svg": "4f9c",
	"./cchat.svg": "b418",
	"./ccon-doi-kaka.svg": "21a7",
	"./cflygram-kaka.svg": "ec15",
	"./cflygram.svg": "bf9f",
	"./cmail-kaka.svg": "397f",
	"./cmail.svg": "be69",
	"./cmeetalk.svg": "f3ef",
	"./cpaopao.svg": "ad6f",
	"./cqq-kaka.svg": "e583",
	"./cqq.svg": "c6bc",
	"./cskype-kaka.svg": "fc3d",
	"./cskype.svg": "c75d",
	"./ctelegram.svg": "a69d",
	"./czalo.svg": "a9d2",
	"./empty.svg": "e0c8",
	"./home/bonus.svg": "b345",
	"./home/money.svg": "6efa",
	"./home/moneybal.svg": "8eae",
	"./home/netprofit.svg": "7353",
	"./home/payment.svg": "875e",
	"./home/profit.svg": "2ad0",
	"./home/rebate.svg": "da00",
	"./imgicon.svg": "6340",
	"./kaka/cs-24-kaka.svg": "d3c6",
	"./kr/kr-logo.svg": "3967",
	"./login/first-liner.svg": "9faa",
	"./login/firstbg.svg": "c5d0",
	"./login/second-liner.svg": "2941",
	"./vi/vilogo.svg": "510a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";